import { render, staticRenderFns } from "./MyReserves.vue?vue&type=template&id=92809010&"
import script from "./MyReserves.vue?vue&type=script&lang=js&"
export * from "./MyReserves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports